import { CardElementName } from "./CardElement"
import { TournamentRanking } from "./Tournament"

export type FFDecksV2TournamentResponseDeck = {
    "datastore_id": number,
    "elements": Record<CardElementName, number>,
    "archetype": string,
    "name": string,
    "tournament_info": {
        "player": string,
        "rank": TournamentRanking
    }
}

export type FFDecksV2TournamentResponse = {
    "website": string,
    "number_of_players": number,
    "description": string,
    "venue_name": string,
    "format": "Standard",
    "views": number,
    "date_submitted": string,
    "decks": FFDecksV2TournamentResponseDeck[],
    "normalized_format": "standard",
    "date": string,
    "datastore_id": number,
    "level": "Local",
    "creator": string,
    "name": string
}

export type FFDecksV2DeckResponseCard = {
    "card": {
        "category": string,
        "is_ex_burst": boolean,
        "is_limit_break": boolean | null,
        "abilities": string[],
        "name": string,
        "power": number | null,
        "image": string,
        "rarity": "Common" | "Rare" | "Hero" | "Legend" | "Starter",
        "is_multi_playable": boolean,
        "job": string,
        "cost": number,
        "datastore_id": number,
        "serial_number": string,
        "type": "Backup",
        "elements": CardElementName[],
        "octgn_id": string
    },
    "quantity": number
};

export type FFDecksV2DeckResponse = {
    "favorites_length": number,
    "name": string,
    "format": "Standard",
    "patreon_status": string,
    "views": number,
    "date_submitted": string,
    "tournament_info": {
        "player": string,
        "rank": TournamentRanking,
        "tournament_id": number,
        "name": string
    },
    "normalized_format": "standard",
    "datastore_id": number,
    "cards": FFDecksV2DeckResponseCard[],
    "is_public": true,
    "last_edited": string,
    "archetype": "Mono Fire",
    "description": string
}

export type FFDecksImportState = {
    isOpen: boolean,
    url: string,
    isLoading: boolean,
    isValidUrl: boolean
}

export function getDefaultFFDecksImportState(): FFDecksImportState {
    return {
        isLoading: false,
        isOpen: false,
        isValidUrl: false,
        url: ""
    }
}